/* Marketing site behavior: env-aware CTA links, scroll reveals, the agent
 * payment demo terminal, and the waitlist form. */

// Point sandbox CTAs at the dashboard subdomain for the current environment.
(() => {
  const h = location.hostname;
  let dash = '';
  if (h === 'obolpay.net' || h === 'www.obolpay.net') dash = 'https://dashboard.obolpay.net';
  else if (h === 'staging.obolpay.net') dash = 'https://dashboard.staging.obolpay.net';
  document.querySelectorAll<HTMLAnchorElement>('a[href="/demo/test"]').forEach((a) => { a.href = dash + '/demo/test'; });
})();

// Staggered reveal on scroll.
const io = new IntersectionObserver((es) => {
  es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
}, { threshold: .12 });
document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

// ---- agent payment demo ----
const feed = document.getElementById('feed');
const meta = document.getElementById('meta');
const replay = document.getElementById('replay') as HTMLButtonElement | null;
let timers: ReturnType<typeof setTimeout>[] = [];

interface Step { t: string; cls: string; html: string }
const steps: Step[] = [
  { t: '0.00s', cls: '', html: '<span class="who">agent_7f3c</span> <span class="txt">→ GET /v1/summarize</span>' },
  { t: '0.04s', cls: 'err', html: '<span class="txt">← 402 Payment Required · quote</span> <span class="amt">0.0200 USDC</span>' },
  { t: '0.21s', cls: '', html: '<span class="who">agent_7f3c</span> <span class="txt">signs &amp; pays</span> <span class="amt">0.0200 USDC</span> <span class="txt">· budget 4.98 left</span>' },
  { t: '0.38s', cls: '', html: '<span class="hold">⟳ escrow holds 0.0200 USDC</span>' },
  { t: '0.9s', cls: '', html: '<span class="txt">provider runs summarize() …</span>' },
  { t: '1.1s', cls: 'ok', html: '<span class="txt">✓ delivery confirmed</span>' },
  { t: '1.2s', cls: 'ok', html: '<span class="txt">✓ escrow released → provider · settled on Base</span>' },
];

function run(): void {
  if (!feed || !meta) return;
  timers.forEach(clearTimeout); timers = [];
  feed.innerHTML = '';
  if (replay) replay.disabled = true;
  meta.innerHTML = 'running · settling payment…';
  let delay = 250;
  steps.forEach((s, i) => {
    const row = document.createElement('div');
    row.className = 'line ' + s.cls;
    row.innerHTML = '<span class="tick">' + s.t + '</span><span class="txt-wrap">' + s.html + '</span>';
    feed.appendChild(row);
    timers.push(setTimeout(() => row.classList.add('show'), delay));
    delay += 360 + (i === 4 ? 320 : 0);
  });
  timers.push(setTimeout(() => {
    const c = document.createElement('div');
    c.className = 'line show';
    c.innerHTML = '<span class="tick"></span><span class="txt"><span class="cursor"></span></span>';
    feed.appendChild(c);
    meta.innerHTML = 'done · <b>settled in 1.2s</b> · fee 0.0001 USDC (0.5%)';
    if (replay) replay.disabled = false;
  }, delay + 200));
}
if (replay) replay.addEventListener('click', run);

const demoEl = document.querySelector('.demo');
if (demoEl) {
  const demoIO = new IntersectionObserver((es) => {
    es.forEach((e) => { if (e.isIntersecting) { run(); demoIO.disconnect(); } });
  }, { threshold: .4 });
  demoIO.observe(demoEl);
}

// ---- waitlist → POST /waitlist ----
const wl = document.getElementById('wl') as HTMLFormElement | null;
if (wl) wl.addEventListener('submit', async (e) => {
  e.preventDefault();
  const input = wl.querySelector('input') as HTMLInputElement | null;
  const btn = wl.querySelector('button') as HTMLButtonElement | null;
  const ok = document.getElementById('ok');
  if (!input || !btn || !ok) return;
  if (!input.value || !input.value.includes('@')) { input.focus(); return; }
  btn.disabled = true; const prev = btn.textContent; btn.textContent = 'Adding…';
  try {
    const res = await fetch('/waitlist', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email: input.value.trim(), source: 'landing' }),
    });
    if (!res.ok) throw new Error('request failed');
    ok.textContent = "✓ You're on the list. Sandbox invite incoming.";
    ok.style.color = 'var(--success)';
    ok.classList.add('show');
    input.value = ''; input.placeholder = 'added ✓';
  } catch {
    ok.textContent = '✕ Something went wrong — try again.';
    ok.style.color = 'var(--danger)';
    ok.classList.add('show');
  } finally {
    btn.disabled = false; btn.textContent = prev;
  }
});
